/**
 * Shared logic for customer status modals (active/inactive).
 * Both CustomerStatusActiveModalComponent and CustomerStatusInactiveModalComponent extend this.
 * Child components declare @Input() isVisible, @Input() isLoading, @Output() close, @Output() confirm.
 */
export abstract class CustomerStatusModalBase {
  onClose(): void {
    (this as any).close.emit();
  }

  onConfirm(): void {
    (this as any).confirm.emit();
  }

  onBackdropClick(event: Event): void {
    if (event.target === event.currentTarget) {
      this.onClose();
    }
  }
}
